$( document ).ready(function() {
    $("#subscribeButton").on("click", function(e) {

		e.preventDefault();

        grecaptcha.enterprise.ready(async () => {
            const token = await grecaptcha.enterprise.execute('6LcVqwIqAAAAAP-ei9UPfbRNytEWXJAFyswD8vMl', {action: 'LOGIN'}).then(function(token) {

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                const form = $("#newsletter-form");
                const url  = form.attr("action");
                const data = form.serialize();

                $('#subscriptionMessage').remove();

                $.ajax({
                    type 		: "POST",
                    url 		: url,
                    data 		: data,
                    dataType 	: 'json',
                    // contentType : false,
                    // cache 		: false,
                    // processData : false,

                    success: function(data) {
                        form.append(`<span id="subscriptionMessage" class="text-white"><strong>${data.message}</strong></span>`)
                    },

                    error: function(data) {
                        form.append(`<span id="subscriptionMessage" class="text-white"><strong>The operation failed. Please try again later!</strong></span>`)
                    },
                });
            });
        });
    });
});
